import { createClient } from '@supabase/supabase-js';
import { Database } from '@travel-dashboard/shared';
import { appFirebaseAuth } from '../context/firebase/firebase';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

/**
 * Supabase client configured to work with Firebase Auth
 * Uses the official Firebase Auth integration via accessToken function
 * Docs: https://supabase.com/docs/guides/auth/third-party/firebase-auth
 */
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  db: {
    // All app tables live in the travel schema (must be listed in the
    // project's exposed schemas under Settings → API)
    schema: 'travel',
  },
  auth: {
    // Disable Supabase auth since we're using Firebase
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
  },
  global: {
    headers: {
      // Pass Firebase JWT token for Supabase RLS
      // This function is called automatically by Supabase for each request
    },
  },
  accessToken: async () => {
    const user = appFirebaseAuth.currentUser;
    if (!user) {
      return null;
    }
    try {
      return await user.getIdToken(false);
    } catch (error) {
      console.error('[Supabase] Error getting Firebase token:', error);
      return null;
    }
  },
});
